






























































import { Component, Mixins } from "vue-property-decorator";
import { BrandConfigKeys } from "@/data/constants";
import { ContrastColor, ContrastMode } from "@/data/enums/ui";
import { IState } from "@/store";
import Context from "@/mixins/context";

@Component({
  components: {
    "client-footer": () => import("@/skeleton/client/clientFooter.vue"),
    "impersonation-ribbon": () =>
      import("@/components/app/global/client/impersonationRibbon.vue")
  }
})
export default class ExpressOrderSkeleton extends Mixins(Context) {
  // Data

  public readonly ContrastColor = ContrastColor;

  // Life-cycle Methods

  public mounted() {
    this.$emit("mounted");
  }

  // Computed

  public get modeStyles() {
    // Color stop 1
    const colorStop1 =
      ((this.$store.state as IState).brand?.config?.[
        BrandConfigKeys.CHECKOUT_SUMMARY_COLOR_STOP1
      ] as string) || "";

    // Exit if `colorStop1` is unset or invalid hex
    if (!colorStop1.startsWith("#"))
      return {
        style: {
          ["--checkout-section-background"]: "var(--brand-color)",
          ["--checkout-section-color"]: "var(--brand-color-contrast)"
        }
      };

    // Color stop 2 (optional)
    const colorStop2 =
      ((this.$store.state as IState).brand?.config?.[
        BrandConfigKeys.CHECKOUT_SUMMARY_COLOR_STOP2
      ] as string) || colorStop1;

    // Contrast mode
    const contrastMode =
      ((this.$store.state as IState).brand?.config?.[
        BrandConfigKeys.CHECKOUT_SUMMARY_CONTRAST_MODE
      ] as ContrastMode) || ContrastMode.LIGHT;

    const style = {
      ["--checkout-color-stop1"]: colorStop1,
      ["--checkout-section-background"]: "var(--brand-color)",
      ["--checkout-section-color"]: "var(--brand-color-contrast)",
      ["--mode-rgb"]: `var(--${contrastMode}-mode-rgb)`,
      ["--mode-color"]: `var(--${contrastMode}-mode-color)`,
      ["--mode-background-color"]: `var(--${contrastMode}-mode-background-color)`,
      ["--mode-border-color"]: `var(--${contrastMode}-mode-border-color)`,
      ["--mode-accent-color"]: `var(--${contrastMode}-mode-accent-color)`
    };

    if (colorStop2.startsWith("#"))
      style["--checkout-color-stop2"] = colorStop2;

    return { style };
  }
}
